var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isValidUrl)?_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v(_vm._s(_vm.linkedin))]):_vm._e(),(!_vm.isValidUrl)?_c('p',[_vm._v(_vm._s(_vm.linkedin))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }